import { DownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import React, { FC } from 'react';
import { DATONG_ELEMENT_PARAMS, DATONG_PAGE_EID } from '@/infrastructure/reporter/datong/constant';

interface IProps {
  status: string;
  textColor: string;
  bgColor: string;
  disabled?: boolean;
  overlay?: React.ReactElement;
  onClick?: () => void;
}

export const StatusText: FC<IProps> = (props) => {
  const renderText = <span
      style={{
        cursor: 'pointer',
        padding: '5px 7px',
        fontSize: '14px',
        color: props.textColor,
        backgroundColor: props.bgColor,
      }}
      dt-eid={DATONG_PAGE_EID.issueListStatus}
      dt-params={`${DATONG_ELEMENT_PARAMS.issueListBtnName}=问题状态`}
    >
      {props.status}
      {props.overlay ? <DownOutlined style={{ marginLeft: '6px' }}/> : null}
    </span>;

  return <div style={{ lineHeight: '26px', cursor: props.disabled ? 'not-allowed' : 'pointer' }}>
    {props.overlay ? (
    <Dropdown overlay={props.overlay} trigger={['click']} disabled={props.disabled} >
      <a className="ant-dropdown-link" style={{ textDecoration: 'none' }}>
        {renderText}
      </a>
    </Dropdown>
    ) : (
    <a
      className="ant-dropdown-link"
      style={{
        textDecoration: 'none',
        pointerEvents: props.disabled ? 'none' : 'auto',
      }}
      onClick={props.onClick}
    >
      {renderText}
    </a>
    )}</div>;
};
